/**
 * Lines that only exist on one date a year. Checked against the live
 * calendar (`packages/shared/src/calendar.ts`), synchronously — a date needs
 * no Dexie read to know itself. When one matches, it replaces the ordinary
 * pool for that key entirely rather than joining it: an exclusive that has
 * to compete for the draw is not exclusive.
 */

import { isHolidayToday, isKateBirthday, type SassContext } from '@gramas/shared'

type Line = (ctx: SassContext) => string

export interface Exclusive {
  when: (date: Date) => boolean
  line: Line
  /**
   * Recorded in her file the first time this is ever shown.
   *
   * Only the ones worth finding carry it — the clock jokes and her own day.
   * The dossier lists the whole set as redacted rows, so somebody who has
   * found two of five can see there are three more without being told what
   * they are. See `glitime/dossier.ts`.
   */
  find?: string
}

export const EXCLUSIVES: Readonly<Record<string, ReadonlyArray<Exclusive>>> = {
  'greeting.morning': [
    {
      when: isKateBirthday,
      line: () => 'Šiandien Katės gimtadienis. Ji apie tai nežino ir jai nerūpi.',
      find: 'kates-gimtadienis',
    },
  ],
  'greeting.night': [
    {
      when: (date) => isHolidayToday(date) && date.getMonth() === 10 && date.getDate() === 2,
      line: () => 'Vėlinės. Mano diena. Uždek žvakę — arba bent jau įrašyk vakarienę.',
      find: 'velines',
    },
  ],
  'log_success.base': [
    {
      when: isKateBirthday,
      line: () => 'Šiandien Katė vienais metais vyresnė. Tu irgi, techniškai.',
    },
  ],
}
